function wu_mc_signup() {
	$('.mc-signupform').ajaxChimp();
}

wu_mc_signup();